import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PutRequest } from "../../services/ApiClientService"
import type { EEnableStatusType } from "../../Enum/EEnableStatusType"

export interface ProductQuickEditItem {
  id: number
  name: string
  valueBase: number
  status: EEnableStatusType
  categoryId: number
  hasStockControl: boolean
  stockQuantity: number
  needKitchen: boolean
  hasPreparationTime: boolean
  preparationTimeMinutes: number
}

interface ProductQuickEditRequest {
  items: ProductQuickEditItem[]
}

export type ProductQuickEditTarget = "meal" | "drink"

export const useQuickEditProducts = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleQuickEditProducts = async (
    target: ProductQuickEditTarget,
    items: ProductQuickEditItem[],
    onSuccess: () => Promise<void>,
  ): Promise<boolean> => {
    try {
      enableLoad()

      const endpoint = target === "meal" ? API_ROUTES.MEAL.QUICK_EDIT : API_ROUTES.DRINK.QUICK_EDIT
    
      const response = await PutRequest<number[], ProductQuickEditRequest>(endpoint, { items })

      if (!response.success) throw new Error(response.message)

      await onSuccess()

      return true
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")
      
      setError(t("label_title_erro"), message)
      
      return false
    } finally {
      disableLoad()
    }
  }

  return { handleQuickEditProducts }
}
